<ion-item class="selectable-input-item" [class.selectable-input-disabled]="disabled">
  <ion-label *ngIf="label" position="stacked" color="primary">{{ label }}</ion-label>
  <ion-input
    [value]="inputValue"
    [placeholder]="placeholder"
    [readonly]="!allowFreeInput || isResolving"
    [disabled]="disabled"
    (ionInput)="onInputChanged($event.detail.value)"
    (ionBlur)="onInputBlur()"
    (keyup.enter)="onInputEnter()">
  </ion-input>
  <ion-spinner *ngIf="isResolving" slot="end" class="selectable-input-resolver-spinner" name="crescent" aria-label="入力値を確認中"></ion-spinner>
  <ion-select
    slot="end"
    class="selectable-input-native-select"
    toggle-icon="chevron-expand-outline"
    [attr.aria-label]="label ? label + 'の候補を表示' : '候補を表示'"
    [value]="selectValue"
    [multiple]="multiple"
    [interface]="interface"
    [interfaceOptions]="interfaceOptions ?? emptyInterfaceOptions"
    [compareWith]="compareWith"
    [placeholder]="selectPlaceholder"
    [disabled]="disabled || isResolving"
    (ionChange)="onSelectChanged($event.detail.value)">
    <ion-select-option *ngFor="let option of internalOptions" [value]="option.value" [disabled]="option.disabled">{{ option.label }}</ion-select-option>
  </ion-select>
</ion-item>
